import React from 'react';

import HomePageInfo from '../../components/DealGPT/HomePageInfo';
import DealGPTContainer from '../../components/DealGPT/ViewModels/DealGPTContainer';

const DealGPT = (): JSX.Element => {
  return (
    <DealGPTContainer>
      <HomePageInfo />
    </DealGPTContainer>
  );
};

export default DealGPT;
